// extracted by mini-css-extract-plugin
module.exports = {"scrollbarHide":"slider-buttons_scrollbarHide__Y3N4W"};